import { render } from "./Home.vue?vue&type=template&id=731e0f79&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=731e0f79&lang=less&scoped=true"
/* custom blocks */
import block0 from "@/locales/Home.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuildhome%2Frepo%2Fsrc%2Fviews%2FHome.vue&lang=yml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731e0f79"]])

export default __exports__